// Horizontal inset of every task modal section below the header row, kept in step with
// $task-modal-content-inset in task_modal.scss for the stylesheet-driven sections.
export const TASK_MODAL_CONTENT_INSET = '22px';

// The line the task modal draws between its sections, and the grey its section headings are set
// in. Mirrored from $app-border-color and $v2-text-gray in variables.scss, the same two the GitHub
// and Comments sections use, so a heading written in styled-components sits in the same chrome as
// the stylesheet-driven ones above and below it. The design system has no token for either: its
// nearest border is #d3d3df, which beside the Comments divider reads as a different line.
//
// Nothing ties these to the stylesheet, so changing either variable there desyncs the one section
// drawn in styled-components. variables.scss carries the reciprocal note, the same pairing
// TASK_MODAL_CONTENT_INSET already has with task_modal.scss.
export const TASK_MODAL_SECTION_DIVIDER_COLOR = '#e6e6e6';
export const TASK_MODAL_SECTION_HEADING_COLOR = '#535353';
